"use strict";

var React = require('react');

var PropTypes = require('prop-types');

var PrintJob = require('../../PrintJob');

var Product = require('../../../products/interfaces/Product');

var Component = require('../../../products/interfaces/Component');

var getComposables = require('../../PrintingDetails/componentComposables');

function ComponentFieldsListWrapper(_ref) {
  var printJob = _ref.printJob,
      product = _ref.product,
      component = _ref.component,
      componentSettings = _ref.componentSettings,
      options = _ref.options,
      fields = _ref.fields;
  var component_type = component.type;
  var component_options = componentSettings[component_type] || componentSettings["default"];
  var values = [];
  fields.forEach(function (_ref2, index) {
    var field = _ref2.field;

    if (!component_options[field]) {
      throw new Error("No options found for ".concat(component_type, " > ").concat(field));
    }

    var text = getComposables(field, component_options[field]).reduce(function (accumulator, fn) {
      return fn(accumulator, printJob, product, component, component_options, options);
    }, '');

    if (text) {
      values[index] = text;
    }
  });
  var list = [];
  fields.forEach(function (_ref3, index) {
    var label = _ref3.label,
        field = _ref3.field,
        Element = _ref3.el;

    if (values[index]) {
      list.push( /*#__PURE__*/React.createElement(Element, {
        key: field
      }, label, " ", values[index], /*#__PURE__*/React.createElement("br", null)));
    }
  });
  return /*#__PURE__*/React.createElement("div", null, list);
}

ComponentFieldsListWrapper.defaultProps = {
  variant: 'FullOrders'
};
ComponentFieldsListWrapper.propTypes = {
  printJob: PropTypes.instanceOf(PrintJob).isRequired,
  product: PropTypes.instanceOf(Product).isRequired,
  component: PropTypes.instanceOf(Component).isRequired,
  options: PropTypes.any,
  componentSettings: PropTypes.shape({
    "default": PropTypes.object.isRequired
  }).isRequired,
  fields: PropTypes.arrayOf(PropTypes.shape({
    field: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    el: PropTypes.oneOfType([PropTypes.func, PropTypes.oneOf(['div', 'span', 'mark', 'p'])])
  })).isRequired,
  variant: PropTypes.oneOf(['TestPrints', 'FullOrders'])
};
module.exports = ComponentFieldsListWrapper;